import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import ACBreadcrumbNavigation from 'academy-common-lib/components/navigation/breadcrumbs/ACBreadcrumbNavigation';
import { Box } from 'foundations-components/transitional/components/Box';
import { H1 } from 'foundations-components/transitional/components/H1';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PageHeader = ({
  breadcrumbs,
  children,
  title,
  subtitle,
  subtitleProps
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const Header = isMobile ? H2 : H1;
  return /*#__PURE__*/_jsxs(TFlex, {
    alignItems: isMobile ? undefined : 'center',
    direction: isMobile ? 'column' : 'row',
    gap: 12,
    marginBlockEnd: isMobile ? '300' : undefined,
    children: [/*#__PURE__*/_jsxs(Box, {
      grow: 1,
      children: [breadcrumbs && breadcrumbs.length > 0 && /*#__PURE__*/_jsx(ACBreadcrumbNavigation, {
        items: breadcrumbs
      }), /*#__PURE__*/_jsx(Header, {
        marginBlockEnd: "200",
        typography: isMobile ? 'heading-400' : 'heading-600',
        children: title
      }), !isMobile && /*#__PURE__*/_jsx(Paragraph, Object.assign({
        marginBlockEnd: "600"
      }, subtitleProps, {
        children: subtitle
      }))]
    }), children]
  });
};